/**
 * Login page — sends the browser to Emergent-managed Google auth.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/authContext";
import { TickdocLogo } from "@/components/TickdocLogo";

export default function Login() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user) nav("/", { replace: true });
  }, [loading, user, nav]);

  const signIn = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain-overlay">
      <div className="w-full max-w-md text-center">
        <TickdocLogo
          variant="full"
          className="mx-auto w-full max-w-[240px] mb-8 text-[#0A0604]"
          title="tickdoc"
        />
        <h1 className="font-serif-display text-4xl text-[#0A0604] mb-2">The Workshop</h1>
        <p className="text-xs uppercase tracking-[0.3em] text-[#3A2A10] mb-10">
          Private — owner access only
        </p>

        <button
          onClick={signIn}
          className="w-full h-12 bg-[#D4AF37] hover:bg-[#E5C158] text-[#0A0C10] text-sm uppercase tracking-wider rounded-sm transition-colors"
          data-testid="login-google-btn"
        >
          Continue with Google
        </button>

        <p className="text-[11px] text-[#3A2A10] mt-6 leading-relaxed">
          The first Google account to sign in becomes the sole owner.
          Subsequent sign-ins from other emails are rejected.
        </p>
      </div>
    </div>
  );
}
